module.exports = __webpack_public_path__ + "img/hu.e542b341.png";